import React from "react";
import './styles.scss'

const MapMarker = ({ popup, index, title, image, description, handleClick }) => {
    return (
      <div id="popup" className={`popup ${popup == index ? 'open' : '' }`}>
          <div className="opacity"></div>
          <div className="popup-inner">
            <div className="close" onClick={ () => handleClick(null) }>&#10005;</div>
            <img src={image} alt={title} />
            <div className="popup-content">
                <div className="title">{title}</div>
                <div className="description">{description}</div>
            </div>
          </div>
      </div>
    )
}

export default MapMarker;